import React, { useState, useEffect } from 'react';
import { Send, Clock, X, Image as ImageIcon } from 'lucide-react';
import { formatTime } from '../utils/helpers';

export default function FeedbackForm({ currentTime, onSubmit, screenshot, onClearScreenshot }) {
    const [text, setText] = useState('');
    const [authorName, setAuthorName] = useState('');

    useEffect(() => {
        const savedAuthor = localStorage.getItem('feedbackAuthorName');
        if (savedAuthor) setAuthorName(savedAuthor);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!text.trim() || !authorName.trim()) return;

        localStorage.setItem('feedbackAuthorName', authorName.trim());
        onSubmit({ text, authorName });
        setText('');
    };

    const handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    return (
        <div className="bg-[#1a1a1a] rounded-xl border border-white/10 p-4 mb-6 shadow-xl">
            <div className="flex items-center justify-between mb-3">
                <h3 className="font-bold text-white flex items-center gap-2">
                    <Clock className="text-cyan-400" size={18} />
                    Add Feedback at <span className="font-mono text-cyan-400">{formatTime(currentTime)}</span>
                </h3>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                <input
                    type="text"
                    placeholder="Your Name"
                    value={authorName}
                    onChange={(e) => setAuthorName(e.target.value)}
                    className="bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-cyan-500 transition-colors w-1/2"
                />

                {screenshot && (
                    <div className="relative w-fit">
                        <img
                            src={screenshot}
                            alt="Annotation preview"
                            className="max-h-24 rounded-lg border border-cyan-500/40 object-contain bg-black/50"
                        />
                        <button
                            type="button"
                            onClick={onClearScreenshot}
                            className="absolute -top-2 -right-2 p-0.5 bg-red-500 hover:bg-red-600 rounded-full text-white"
                            title="Remove screenshot"
                        >
                            <X size={12} />
                        </button>
                        <span className="flex items-center gap-1 text-xs text-cyan-400 mt-1">
                            <ImageIcon size={11} /> Annotation attached
                        </span>
                    </div>
                )}

                <div className="relative">
                    <textarea
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Type your feedback here... (Ctrl+Enter to send)"
                        className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-sm text-white focus:outline-none focus:border-cyan-500 transition-colors resize-none min-h-[80px]"
                    />
                    <button
                        type="submit"
                        disabled={!text.trim() || !authorName.trim()}
                        className="absolute bottom-3 right-3 p-2 bg-cyan-500 hover:bg-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg text-white transition-all shadow-lg hover:shadow-cyan-500/20"
                    >
                        <Send size={16} />
                    </button>
                </div>
            </form>
        </div>
    );
}
